import { useAtom, useAtomValue } from 'jotai';

import { Label } from '@crossnokaye/ux-common';

import { useSelectAll } from '@/features/trends/components/selections-sidebar/hooks/use-select-all';
import { useSelectionGroups } from '@/features/trends/components/selections-sidebar/hooks/use-selection-groups';
import SelectionState from '@/features/trends/components/selections-sidebar/state/selections.state';
import { useAttributeSelection } from '@/features/trends/state/hooks/use-attribute-selection';
import { Button } from '@/ux-common/components/button/button';
import { Checkbox } from '@/ux-common/components/checkbox/checkbox';
import { Inline } from '@/ux-common/components/inline/inline';
import { Stack } from '@/ux-common/components/stack/stack';
import { Switch } from '@/ux-common/components/switch/switch';

export const SelectionsActionSection = () => {
  const [showAdvanced, setShowAdvanced] = useAtom(SelectionState.showAdvanced);
  const searchTerm = useAtomValue(SelectionState.searchTerm);
  const selectionGroups = useSelectionGroups();

  const { clearAttributesAction } = useAttributeSelection();
  const { checkedState, handleSelectAllChange, visibleAttributesCount } = useSelectAll({
    selectionGroups,
  });

  return (
    <Stack className="stack-sm w-full">
      <Inline className="inline-row-thin flex-nowrap justify-between w-full">
        <Inline className="inline-row-sm flex-nowrap">
          <Switch id="show-advanced" checked={showAdvanced} onCheckedChange={setShowAdvanced} />
          <Label htmlFor="show-advanced" className="text-sm text-foreground w-26">
            Show Advanced
          </Label>
        </Inline>
        <Button className="btn btn-tier2 btn-sm w-26 px-1" onClick={clearAttributesAction}>
          Clear All
        </Button>
      </Inline>
      {searchTerm && visibleAttributesCount > 0 && (
        <Checkbox
          id="select-all"
          label="Select All"
          checked={checkedState}
          onCheckedChange={handleSelectAllChange}
        />
      )}
    </Stack>
  );
};
